module.exports = __webpack_public_path__ + "static/media/Low.a9cd467e.jpg";